import Vue from 'vue';

import store from './store';

function init(){
  let language = window.localStorage.getItem("language");
  console.log(language);
  if(!language){
    store.state.language="zh";
  }else{
    store.state.language=language;
  }
}

function set(language){
  store.state.language=language;
  window.localStorage.setItem("language",language);
}

function get(){
  if(!store.state.language){
    let language = window.localStorage.getItem("language");
    if(!language){
      set("zh");
    }else{
      store.state.language=language;
    }
  }
  return store.state.language;
}

function text(zh,en){
  return get() == "en" ? en : zh;
}

export default {
  set,get,text,init
};



// WEBPACK FOOTER //
// ./src/language.js